// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"141":"history","474":"revew","485":"game","857":"report","884":"admin","966":"login"}[chunkId] || chunkId) + "-legacy." + {"141":"18ed3df3","474":"244dc23f","485":"59a870bb","507":"f5ed5352","811":"00b90fb5","857":"cb91f28e","884":"adf951c1","966":"89291527"}[chunkId] + ".js";
};